import ResultSolutionDetails from './ResultSolutionDetails';

export default ResultSolutionDetails;
